import { Box, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import propTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  messageBox: {
    padding: '8px',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  disabledBox: {
    background: 'rgba(224, 224, 224, .4)',
    bottom: 0,
    left: 0,
  },
}));

function MessageBox(props) {
  const classes = useStyles();
  return (
    <Grid container alignItems="center" className={classes.messageBox}>
      {props.disabled && (
        <Box position="absolute" width="100%" height="100%" className={classes.disabledBox} />
      )}
      {props.children}
    </Grid>
  );
}

const Props = {
  children: propTypes.node.isRequired,
  disabled: propTypes.bool,
};

MessageBox.propTypes = Props;

export default MessageBox;
